import React from "react";
import {useSelector} from "react-redux";
import {translate} from "../Language/Translate";

const FirstStepsLoggedIn = () => {
  const currentUser = useSelector(st => st.currentUser);
  // console.log('inside FirstStepsLoggedIn', currentUser)
  const FirstStepsLoggedInOptions = () => (
    <div className="text-center mt-5">
      <h3>{`${translate("Welcome")}, ${currentUser.firstName} ${currentUser.lastName} !`}</h3>
      <p>Zum Einstieg klicken Sie bitte oben auf "Schulen", und wählen Sie dort "Schulen" aus.</p>
    </div>
  );
  return <FirstStepsLoggedInOptions />;
};
export default FirstStepsLoggedIn;
